import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { HistogramPlot } from "../components/HistogramPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.hist_tool_name()}
        toolPath="/histogram"
      />
      <SciHeader title={m.hist_h1()} intro={m.hist_intro()} />

      <HistogramPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.hist_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.hist_ex1(), m.hist_ex2(), m.hist_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.hist_faq_q1(), a: m.hist_faq_a1() },
          { q: m.hist_faq_q2(), a: m.hist_faq_a2() },
          { q: m.hist_faq_q3(), a: m.hist_faq_a3() },
          { q: m.hist_faq_q4(), a: m.hist_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
